export class Motivo {
    public id!: number | null;
    public ativo!: boolean;
    public descricao!: string;
    public pendenciaRecusa!: string;
  }